import { ButtonColor, ButtonTypes } from "@/core/@types/types";

export const ContabilButtonColors: Record<keyof ButtonColor, string> = {
  [ButtonTypes.primary]: "#afd249",
  [ButtonTypes.success]: "#dfsa",
  [ButtonTypes.warning]: "#fdsf"
};

export enum TipoDeDownload {
  None = 0,
  Ecf = 1,
  EfdPisCofins = 2,
  CartaoCnpj = 3,
  Cadin = 4,
  SituacaoFiscal = 5,
  Pgdas = 6,
  Das = 7,
  DebitosPGDAS = 8,
  Defis = 9,
  FontesPagadoras = 10,
  Dctf = 11
}

export enum RegimeTributarioEnum {
  None = 0,
  DeclaranteNaoeContribuintedoIrpj = 1,
  LucroReal = 2,
  LucroRealArbitrado = 3,
  LucroPresimudoReal = 4,
  LucroPresimudoRealArbitrado = 5,
  LucroPresumido = 6,
  LucroPresumidoArbitrado = 7,
  ImuneDoIrpj = 9,
  IsentaDoIrpj = 10,
  Todos = 11,
  Simples = 12,
  Novo = 13,
  MEI = 14
}

export const RegimeTributarioDescription = new Map<
  RegimeTributarioEnum,
  string
>([
  [
    RegimeTributarioEnum.DeclaranteNaoeContribuintedoIrpj,
    "Declarante não Contribuinte do IRPJ"
  ],
  [RegimeTributarioEnum.ImuneDoIrpj, "Imune do IRPJ"],
  [RegimeTributarioEnum.IsentaDoIrpj, "Isenta do IRPJ"],
  [RegimeTributarioEnum.LucroPresimudoReal, "Lucro Presumido Real"],
  [
    RegimeTributarioEnum.LucroPresimudoRealArbitrado,
    "Lucro Presumido Real Arbitrado"
  ],
  [RegimeTributarioEnum.LucroPresumido, "Lucro Presumido"],
  [RegimeTributarioEnum.LucroPresumidoArbitrado, "Lucro Presumido Arbitrado"],
  [RegimeTributarioEnum.LucroReal, "Lucro Real"],
  [RegimeTributarioEnum.LucroRealArbitrado, "Lucro Real Arbitrado"],
  [RegimeTributarioEnum.Simples, "Simples Nacional"],
  [RegimeTributarioEnum.Todos, "Todos"],
  [RegimeTributarioEnum.None, "-"],
  [RegimeTributarioEnum.Novo, "*"],
  [RegimeTributarioEnum.MEI, "MEI"]
]);

export interface IDefaultContabilCnpjResponse {
  completo: string | null;
  raiz: string | number;
  filial: string | number;
}
